export enum TransactionOperationTableColumnKey {
  BatchID = 'batchId',
  OperationSequence = 'operationSequence',
  MerchantOrderID = 'merchantOrderId',
  Version = 'version',
  Path = 'path',
  OperationType = 'operationType',
  SendingAddress = 'sendingAddress',
  ReceivingAddress = 'receivingAddress',
  WalletTagOfReceivingAddress = 'walletTagOfReceivingAddress',
  // Currency = 'currency',
  Amount = 'amount',
  CreationTime = 'creationTime',
  LastModifiedTime = 'lastModifiedTime',
}

export interface TransactionOperationTableRow {
  id: string | number;
  [TransactionOperationTableColumnKey.BatchID]: string;
  [TransactionOperationTableColumnKey.OperationSequence]: string;
  [TransactionOperationTableColumnKey.MerchantOrderID]: string;
  [TransactionOperationTableColumnKey.Version]: string;
  [TransactionOperationTableColumnKey.Path]: string;
  [TransactionOperationTableColumnKey.OperationType]: string;
  [TransactionOperationTableColumnKey.SendingAddress]: string;
  [TransactionOperationTableColumnKey.ReceivingAddress]: string;
  [TransactionOperationTableColumnKey.WalletTagOfReceivingAddress]: string;
  // [TransactionOperationTableColumnKey.Currency]: string;
  [TransactionOperationTableColumnKey.Amount]: string;
  [TransactionOperationTableColumnKey.CreationTime]: string;
  [TransactionOperationTableColumnKey.LastModifiedTime]: string;
  rawData: any;
}
